import { DateTime } from 'luxon';

import { DateUtilities } from '../utils';

export class VisualDay
{
    /**
     * Reference date
     */
    date: DateTime;

    /**
     * day in the month
     */
    day: number;

    /**
     * Is this day today?
     */
    isToday: boolean;

    /**
     * Is this day in the current month?
     */
    isInCurrentMonth: boolean;

    /**
     * Is this day between the min and max dates?
     */
    isCheckable: boolean;

    /**
     * Is this day a saturday or a sunday?
     */
    isWeekend: boolean;

    /**
     * Is this date between since and until?
     */
    isInRange: boolean = false;

    /**
     * Est-ce que la date est une des dates bornes, cliquée : since ou until
     */
    isBoundary: boolean = false;

    /**
     *
     */
    constructor (d: DateTime, firstDay: DateTime, minDate: DateTime, maxDate: DateTime, sinceDate?: DateTime, untilDate?: DateTime)
    {
        this.date = d;
        this.isInCurrentMonth = DateUtilities.isInSameMonth(this.date, firstDay);
        this.day = d.day;
        this.isWeekend = DateUtilities.isWeekend(this.date);
        this.isCheckable = DateUtilities.isBetween(this.date, minDate, maxDate);
        this.isToday = DateUtilities.isToday(this.date);
        this.isBoundary = DateUtilities.isEqual(this.date.startOf('day'), sinceDate.startOf('day')) || DateUtilities.isEqual(this.date.startOf('day'), untilDate.startOf('day'));

        if (sinceDate !== null && untilDate !== null)
        {
            this.isInRange = DateUtilities.isStrictlyBetween(this.date, sinceDate, untilDate);
        }
    }
}
